import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { InExperimentContainer } from '@saucelabs/sl-container-experiment';
import { Row, Col } from '@saucelabs/sl-component-grid';
import { FormToggle, FormToggleOption } from '@saucelabs/sl-component-form';
import { Loader } from '@saucelabs/sl-component-loader';
import { records as jobsRecords } from '@saucelabs/sl-module-jobs';

import { actions, constants, selectors } from './../ducks/flatJobs';
import AutomatedJobsEmptyState from './EmptyState/AutomatedJobsEmptyState';
import RdcJobsEmptyState from './EmptyState/RdcJobsEmptyState';
import AutomatedJobs from './AutomatedJobs';
import AutomatedJobsFilters from './AutomatedJobsFilters';
import RdcJobs from './RdcJobs';
import RdcErrorPage from './../containers/RdcErrorPage';
import Styles from './../containers/JobsContainer.styles';

const AutomatedJobsTab = ({
  automated,
  automatedLoading,
  changeTab,
  clearStatuses,
  cloudType,
  decreaseRdcOffset,
  filtersInitialized,
  increaseRdcOffset,
  isOpenSauceUser,
  isPerformanceEnabled,
  noFilters,
  owners,
  ownership,
  performance,
  rdc,
  rdcLessAvailable,
  rdcLoading,
  rdcMoreAvailable,
  selectOwner,
  showOwnersFilter,
  showSeeAllButton,
  status,
  togglePerformance,
  trackedToggleStatus,
  username,
}) => {
  const renderRDC = () => {
    if (rdcLoading) {
      return (
        <Loader
          className={Styles.loader}
          fontSize={3}
        />
      );
    }
    return (
      <RdcErrorPage>
        {rdc.size === 0 && noFilters ?
          <RdcJobsEmptyState /> : (
            <RdcJobs
              jobs={rdc}
              newerAvailable={rdcLessAvailable}
              olderAvailable={rdcMoreAvailable}
              onClickNewer={decreaseRdcOffset}
              onClickOlder={increaseRdcOffset}
            />
          )}
      </RdcErrorPage>
    );
  };

  const renderAutomated = () => {
    if (automatedLoading) {
      return (
        <Loader
          className={Styles.loader}
          fontSize={3}
        />
      );
    }
    return automated.size === 0 && noFilters && !isOpenSauceUser ?
      <AutomatedJobsEmptyState /> : (
        <AutomatedJobs
          isOpenSauceUser={isOpenSauceUser}
          jobs={automated}
          selectedPerfOption={performance}
          showSeeAllButton={showSeeAllButton}
        />
      );
  };

  return (
    <div>
      <Row>
        <InExperimentContainer
          name="web-ui-jobs-rdc"
          showLoader={false}
        >
          <Col sm>
            <div className={Styles['cloud-type']}>
              <FormToggle activeKey={cloudType}>
                <FormToggleOption
                  eventKey={constants.VIRTUAL_DEVICE_CLOUD}
                  label="Virtual Cloud"
                  onClick={() => changeTab(constants.TAB_VIRTUAL)}
                />
                <FormToggleOption
                  eventKey={constants.REAL_DEVICE_CLOUD}
                  label="Real Devices"
                  onClick={() => changeTab(constants.TAB_REAL)}
                />
              </FormToggle>
            </div>
          </Col>
        </InExperimentContainer>
        <Col
          className={Styles['status-filter']}
          sm
        >
          {filtersInitialized ? (
            <AutomatedJobsFilters
              clearStatuses={clearStatuses}
              isPerformanceEnabled={isPerformanceEnabled}
              owners={owners}
              ownership={ownership}
              performance={performance}
              selectOwner={selectOwner}
              showOwnersFilter={showOwnersFilter}
              status={status}
              togglePerformance={togglePerformance}
              toggleStatus={trackedToggleStatus}
              username={username}
            />
          ) : null}
        </Col>
      </Row>
      {cloudType === constants.REAL_DEVICE_CLOUD ? renderRDC() : renderAutomated()}
    </div>
  );
};

const mapDispatchToProps = {
  decreaseRdcOffset: actions.decreaseRdcOffset,
  increaseRdcOffset: actions.increaseRdcOffset,
};

AutomatedJobsTab.propTypes = {
  automated: ImmutablePropTypes.listOf(
    ImmutablePropTypes.recordOf(jobsRecords.JobRecordClass).isRequired,
  ).isRequired,
  automatedLoading: PropTypes.bool.isRequired,
  changeTab: PropTypes.func.isRequired,
  clearStatuses: PropTypes.func.isRequired,
  cloudType: PropTypes.oneOf(constants.CLOUD_TYPES).isRequired,
  decreaseRdcOffset: PropTypes.func.isRequired,
  filtersInitialized: PropTypes.bool.isRequired,
  increaseRdcOffset: PropTypes.func.isRequired,
  isOpenSauceUser: PropTypes.bool.isRequired,
  isPerformanceEnabled: PropTypes.bool.isRequired,
  noFilters: PropTypes.bool.isRequired,
  owners: PropTypes.array.isRequired,
  ownership: PropTypes.object.isRequired,
  performance: PropTypes.string.isRequired,
  rdc: ImmutablePropTypes.listOf(
    ImmutablePropTypes.recordOf(jobsRecords.JobRecordClass).isRequired,
  ).isRequired,
  rdcLessAvailable: PropTypes.bool.isRequired,
  rdcLoading: PropTypes.bool.isRequired,
  rdcMoreAvailable: PropTypes.bool.isRequired,
  selectOwner: PropTypes.func.isRequired,
  showOwnersFilter: PropTypes.bool.isRequired,
  showSeeAllButton: PropTypes.bool.isRequired,
  status: ImmutablePropTypes.list.isRequired,
  togglePerformance: PropTypes.func.isRequired,
  trackedToggleStatus: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
};

export default connect(
  selectors.automatedJobsSelector,
  mapDispatchToProps,
)(AutomatedJobsTab);
export {
  AutomatedJobsTab,
  mapDispatchToProps,
};
